import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FieldBinaryOutlinedSvg from "@ant-design/icons-svg/es/asn/FieldBinaryOutlined";
import AntdIcon from "../components/AntdIcon";
var FieldBinaryOutlined = function FieldBinaryOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FieldBinaryOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FieldBinaryOutlined.displayName = 'FieldBinaryOutlined';
}
export default /*#__PURE__*/React.forwardRef(FieldBinaryOutlined);